import type { Link } from './footer';

/**
 * 组件的props
 */
export const props = {
  /**
   * 链接数组
   * @default []
   */
  links: {
    type: Array<Link>,
    default: [],
  },
  /**
   * 底部描述
   * @default ''
   */
  desc: {
    type: String,
    default: '',
  },
};
